<div class="case-dialog custom-dialog-container">
  <h1 mat-dialog-title>{{ data.caption }}</h1>
  <div mat-dialog-content>
    <div class="container">

      <div class="row">

        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
          <ng-container *ngIf="data.video">
            <iframe [src]="videoSafeLink" width="100%" height="400" title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;"
                    allowfullscreen></iframe>
          </ng-container>
          <ng-container *ngIf="data.preview">
            <div>
              <img style="width: 100%; height: 100%; max-width: 100%;" [src]="data.preview" alt="preview">
            </div>
          </ng-container>
        </div>

        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">

          <ng-container *ngIf="data.link">
            <div class="row">
              <img src="assets/icon-link.png" alt="">
              <a [href]="data.link" target="_blank">
                GOTO SITE
                <ng-container *ngIf="data.isDesignOnly"> (is design only)</ng-container>
              </a>
            </div>
          </ng-container>

          <div class="row">
            <span style="padding: 1em;">{{ data.description }}</span>
          </div>

          <ng-container *ngIf="data.TTC">
            <div class="row">
              <div class="row">
                <img src="assets/icon-time.png" alt="">
                <p class="property-caption">Time to Completion</p>
              </div>
              <p>{{ data.TTC }}</p>
            </div>
          </ng-container>

          <ng-container *ngIf="data.repoLink">
            <div class="row">
              <div class="row">
                <img src="assets/icon-github.png" alt="">
                <ng-container *ngIf="data.repoLink !== 'NDA'">
                  <a [href]="data.repoLink" target="_blank">Source code</a>
                </ng-container>
                <ng-container *ngIf="data.repoLink == 'NDA'">
                  <p>NDA</p>
                </ng-container>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="data.usingTechnologies">
            <div class="row">
              <div class="row">
                <img src="assets/icon-tools.png" alt="">
                <p class="property-caption">Used Technologies:</p>
              </div>
              <p *ngFor="let tool of data.usingTechnologies; index as i" class="tool">{{ tool }}
                <!--              <ng-container *ngIf="i !== data.usingTechnologies.length-1">, </ng-container>-->
              </p>
            </div>
          </ng-container>

        </div>
      </div>

      <!--      <div class="row">-->
      <!--        <div class="col">-->

      <!--          -->

      <!--          -->
      <!--        </div>-->
      <!--        <div class="col">-->

      <!--          -->

      <!--        </div>-->
      <!--      </div>-->

    </div>
  </div>
  <div mat-dialog-actions>
    <!--  <button mat-button (click)="onNoClick()">No Thanks</button>-->
    <!--  <button mat-button [mat-dialog-close]="data.animal" cdkFocusInitial>Ok</button>-->
  </div>
</div>
